import Client from '@/commonFunc/client.js'
import docsRoutes from '@/router/docs.js'
import BaseConfig from '@/config/base.js'
import { resolveLandingExternalSource } from '@/utils/landing-traffic.js'

/** 官网仅统计 P3_Page 相关路由 */
const OFFICIAL_WEBSITE_PATHS = new Set(docsRoutes.map((r) => r.path))

/** 顺序即优先级：先匹配客户端 H5，再匹配官网 */
const TA_PAGE_VIEW_STRATEGIES = [
  {
    match: (ctx) => ctx.hasLogin,
    eventName: 'page_view_h5',
  },
  {
    match: (ctx) => !ctx.hasLogin && OFFICIAL_WEBSITE_PATHS.has(ctx.to.path),
    eventName: 'page_view_official_website',
  },
]

function resolveTaPageViewEventName(to, from) {
  try {
    const { uid, token } = Client.getUserBaseInfo()
    const ctx = { to, from, hasLogin: !!(uid && token) }
    const hit = TA_PAGE_VIEW_STRATEGIES.find((s) => s.match(ctx))
    return hit ? hit.eventName : null
  } catch (e) {
    console.log('resolveTaPageViewEventName', e)
    return null
  }
}

const queue = []

export function trackTaPageView(eventName, props) {
  if (!BaseConfig.isRelease) return
  try {
    // 已初始化
    if (window.ta) {
      window.ta.track(eventName, props)
    }
    // 未初始化放在队列
    else {
      queue.push({ eventName, props })
    }
  } catch (e) {
    console.log('trackTaPageView', e)
  }
}

export function flushTaPageViewQueue() {
  if (!window.ta || !queue.length) return
  while (queue.length) {
    const { eventName, props } = queue.shift()
    try {
      window.ta.track(eventName, props)
    } catch (e) {
      console.log('flushTaPageViewQueue', e)
    }
  }
}

function buildPageUrl(to, isHistoryMode) {
  try {
    if (to && to.path) {
      const path = to.fullPath || to.path
      return isHistoryMode ? `${window.location.host}${path}` : `${window.location.host}/#${path}`
    }
    const href = window.location.href
    const queryIndex = href.indexOf('?')
    return queryIndex === -1 ? href : href.slice(0, queryIndex)
  } catch (e) {
    console.log('buildPageUrl', e)
    return 'unknown'
  }
}

function isIntrasiteNavigation(from) {
  return from && Array.isArray(from.matched) && from.matched.length > 0
}

function buildPageFrom(from, isHistoryMode) {
  try {
    if (isIntrasiteNavigation(from)) {
      const p = from.fullPath || from.path || '/'
      return isHistoryMode ? `${window.location.host}${p}` : `${window.location.host}/#${p}`
    }
    return resolveLandingExternalSource()
  } catch (e) {
    console.log('buildPageFrom', e)
    return 'unknown'
  }
}

function buildPayload(to, from, isHistoryMode) {
  try {
    return {
      page_url: buildPageUrl(to, isHistoryMode),
      page_from: buildPageFrom(from, isHistoryMode),
    }
  } catch (e) {
    console.log('buildPayload', e)
    return {
      page_url: 'unknown',
      page_from: 'unknown',
    }
  }
}

/**
 * 有登录信息 → 客户端 H5（page_view_h5）
 * 无登录且为官网静态页路由 → page_view_official_website
 */
export function registerTaRoutePageView(router, isHistoryMode = false) {
  router.afterEach((to, from) => {
    if (!BaseConfig.isRelease) return
    try {
      const eventName = resolveTaPageViewEventName(to, from)
      if (!eventName) return
      trackTaPageView(eventName, buildPayload(to, from, isHistoryMode))
    } catch (e) {
      console.log('registerTaRoutePageView afterEach', e)
    }
  })
}
